
import { Loader } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LoadingProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  className?: string;
}

export const Loading = ({ size = 'md', text, className }: LoadingProps) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8'
  };

  return (
    <div className={cn('flex items-center justify-center gap-2', className)}>
      <Loader className={cn('animate-spin text-primary', sizeClasses[size])} />
      {text && <span className="text-sm text-muted-foreground">{text}</span>}
    </div>
  );
};

interface LoadingSpinnerProps {
  className?: string;
}

export const LoadingSpinner = ({ className }: LoadingSpinnerProps) => {
  return (
    <div className={cn('flex items-center justify-center p-8', className)}>
      <Loading size="lg" text="Carregando..." />
    </div>
  );
};

interface LoadingOverlayProps {
  isLoading: boolean;
  children: React.ReactNode;
}

export const LoadingOverlay = ({ isLoading, children }: LoadingOverlayProps) => {
  if (isLoading) {
    return (
      <div className="relative">
        <div className="opacity-50">{children}</div>
        <div className="absolute inset-0 flex items-center justify-center bg-background/50">
          <Loading size="lg" text="Processando..." />
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
